import axios from 'axios';
import { LoginService } from "../_services/login.service";
function refreshToken() {
    const refreshToken = window.localStorage.getItem("refreshToken");
    return "sample_token_123456";
  }
export function JwtInterceptor(auth) {
    let isRefresh = false;
    axios.interceptors.request.use(request => {
     
        // add auth header with jwt if account is logged in and request is to the api url
        const token = localStorage.getItem('access_token');
        
        const userId = localStorage.getItem('userId');
        const refreshToken = localStorage.getItem('refresh_token');
     //   console.log(request.url);
        if (token && !(request.url.endsWith("login") )) {
         
            request.headers.common.Authorization = `Bearer ${token}`;
            request.headers.common.userId = `${userId}`;
            request.headers.common.deviceId = "web";
        }

        if ((request.url.endsWith("refreshToken") )) {
         
            request.headers.common.Authorization = `Bearer ${refreshToken}`;
            request.headers.common.userId = `${userId}`;
            request.headers.common.deviceId = "web";
        }

        if ((request.url.endsWith("most-used-analytics") )) {
         
            request.headers.common.authToken = "sample_token_123456";
            request.headers.common.userId = `${userId}`;
            request.headers.common.deviceId = "web";
        }

      

        return request;
    });
    axios.interceptors.response.use(
        (response) => responseHandler(response),
        (error) => errorHandler(error));

    function responseHandler(response) {
        return response;
    }

    async function errorHandler(error) {
        const originalConfig = error.config;
      
        if(error.response.status === 401){
            originalConfig._retry = false;
        }
        if (error.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;
            try {
             
                if(isRefresh==false){
                    isRefresh = true;
                    const rs = await LoginService.getRefreshToken();
                    isRefresh = false;
                    localStorage.setItem('access_token',rs.access_token);
                    localStorage.setItem('refresh_token',rs.refresh_token);
                    localStorage.setItem("loginTime", Date.now());
                                 
                }
                originalConfig.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
                return axios(originalConfig);
                       
        
            } catch (_error) {
              if (_error.response && _error.response.data) {
                return Promise.reject(_error.response.data);
              }
              return Promise.reject(_error);
            }
          
        } else if(error  && error.response.status === 502) {
           
            return Promise.reject(502);
        
    } else if(error && error.response && error.response.status === 422) {
           
        return Promise.reject(422);
    }else {
            return Promise.reject(error);
        }
    }

}